import type { ExerciseTypeConfig } from '../registry/types';
import type { RecordedExerciseDefinition, RecordedExerciseSubmission } from '../types';
import { recordedSubmissionSchema } from '../types/schemas';

/**
 * Get the normalized max score from a definition
 */
function getNormalizedMaxScore(definition: RecordedExerciseDefinition, fallback: number): number {
  const maxScore = definition.maxScore;
  if (typeof maxScore === 'number' && Number.isFinite(maxScore) && maxScore > 0) {
    return maxScore;
  }
  return fallback;
}

/**
 * Recorded exercise type configuration
 */
export const recordedConfig: ExerciseTypeConfig<
  'Recorded',
  RecordedExerciseDefinition,
  RecordedExerciseSubmission,
  { kind: string }
> = {
  type: 'Recorded',
  isAutoGradable: false,
  submissionSchema: recordedSubmissionSchema,

  defaultMaxScore: (definition) => {
    return getNormalizedMaxScore(definition, 100);
  },

  hydrateDetails: (serverDetails: unknown) => {
    const details = serverDetails as Record<string, unknown> | null ?? {};
    return {
      maxDurationSec: details.maxDurationSec ?? 60,
    };
  },

  createDefault: (order) => ({
    type: 'Recorded' as const,
    maxDurationSec: 60,
  }),
};
